import circles from './circles.svg'
import lines from './lines.svg'
import dots from './dots.svg'

export const patternMap = {
  circles: circles,
  lines: lines,
  dots: dots,
}
